import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { TestComponent } from '../../components/test/test.component';
import { QuestionComponent } from '../../question/question/question.component';
import { QuestionService } from '../../services/question.service';
import type { Evaluation, Question } from '../../interfaces/questionInterface';
import { AnswerComponent } from '../../question/answer/answer.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { RouterLink } from '@angular/router';
import { NgIconComponent } from '@ng-icons/core';
import { RepeatListComponent } from '../list/list.component';
import { Chance } from 'chance';

@Component({
    selector: 'app-repeat-execution',
    imports: [TestComponent, QuestionComponent, AnswerComponent, ModalComponent, NgIconComponent, RouterLink, RepeatListComponent],
    templateUrl: './execution.component.html',
    styleUrl: './execution.component.scss'
})
export class RepeatExecutionComponent implements OnInit {
  public activeQuestion?: Question;
  public flagged: boolean = false;
  public currentAnswers: string[] = [];

  public evaluation?: Evaluation;
  public total = 0;
  public initialTotal = 1;

  private activeQuestionSelectedTime: Date = new Date();
  public orderSeed: string = new Chance().string({length: 16});

  @ViewChild(TestComponent)
  private testComponent!: TestComponent;

  @ViewChild('progressbar', { read: ElementRef })
  private progressbar!: ElementRef<HTMLDivElement>;

  @ViewChild('questionOverviewModal')
  questionOverviewModal!: ModalComponent;

  @ViewChild(RepeatListComponent)
  questionOverview!: RepeatListComponent;

  currentResponseId: string = '';

  constructor(
    private questionService: QuestionService
  ) { }

  ngOnInit(): void {
    this.questionService.getIncorrectQuestion().then(question => {
      if (question) {
        this.activeQuestion = question;

        this.questionService.getOneFlaggedQuestion(this.activeQuestion.id).then(flagged => {
          if (flagged) {
            this.flagged = true;
          }
        });

        this.questionService.getIncorrectQuestionCount().then(count => {
          this.initialTotal = count;
        });
      }
    });
  }

  async nextQuestion(questionId?: string): Promise<void> {
    await this.testComponent.fadeOut();

    if (!!questionId) {
      this.activeQuestion = await this.questionService.getOneQuestion(questionId);
    } else {
      this.activeQuestion = await this.questionService.getIncorrectQuestion();
    }
    this.evaluation = [];
    this.activeQuestionSelectedTime = new Date();
    this.flagged = false;

    if (this.activeQuestion) {
      this.questionService.getOneFlaggedQuestion(this.activeQuestion.id).then(flagged => {
        if (flagged) {
          this.flagged = true;
        }
      });
    }
    await this.testComponent.fadeIn();
  }

  async submitAnswer(): Promise < void> {
      if(!this.activeQuestion) return;

      const elapsedSeconds = (new Date().getTime() - this.activeQuestionSelectedTime.getTime()) / 1000;

      const result = await this.questionService.submitEndlessAnswer(this.activeQuestion.id, this.currentAnswers, elapsedSeconds, false, this.orderSeed);
      this.evaluation = result.evaluation;
      this.currentResponseId = result.responseId;
      this.currentAnswers = [];

      if(this.evaluation?.every(e => e.hit)) {
        this.total++;
        this.updateProgressBar();
      }
  }

  handleAnswersSelected(answers: string[]): void {
    this.currentAnswers = answers;
  }

  async handleQuestionFlagged(): Promise<void> {
    this.flagged = !this.flagged;

    if (this.flagged && this.activeQuestion) {
      await this.questionService.flagQuestion(this.activeQuestion.id);
    } else if (this.activeQuestion) {
      await this.questionService.unflagQuestion(this.activeQuestion.id);
    }
  }

  updateProgressBar() {
    const progress = this.total / this.initialTotal * 100;
    this.progressbar.nativeElement.style.width = `${progress}%`;
  }

  async showQuestionsOverview(): Promise<void> {
    const questions = await this.questionService.getIncorrectQuestions();
    this.questionOverview.model = questions;
    this.questionOverview.clearFilter();
    this.toggleQuestionOverview();
  }

  public toggleQuestionOverview() {
    this.questionOverviewModal.toggleModal();
  }
}
